import React from 'react';
import Link from 'components/AppSafeLink/AppSafeLink';
import Icon from '../Icons/Icon';
import PropTypes from 'prop-types';
import '/public/css/components/donateAsk.css';

const DonateAsk = (props) => {
  const containerClass = props?.nodeData?.attrs?.size
    ? `donate-ask donate-ask-${props.nodeData.attrs.size}`
    : `donate-ask ${props.elementClass}`;
  return props?.context?.info?.title ? (
    <>
      <div className={containerClass}>
        <div className="donate-ask-header">
          <h2 className="hdg hdg-2">{props?.context?.info?.title}</h2>
        </div>
        <div className="donate-ask-body">
          <p>{props?.context?.info?.description}</p>
        </div>
        <div className="donate-ask-footer">
          <Link
            href="https://support.mpr.org/mprnews-instory"
            className="btn btn-primary small-gap"
          >
            <span className="type-lg">♡</span>{' '}
            {props?.context?.info?.buttonText}
          </Link>
        </div>
      </div>
    </>
  ) : (
    ' '
  );
};

DonateAsk.propTypes = {
  elementClass: PropTypes.string,
  context: PropTypes.shape({
    info: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      buttonHref: PropTypes.string,
      buttonText: PropTypes.string,
    }),
  }),
  nodeData: PropTypes.shape({
    attrs: PropTypes.shape({
      title: PropTypes.string,
      size: PropTypes.string,
    }),
  }),
};
export default DonateAsk;
